import React, { useEffect } from 'react';
import {
  ExhibitionContainer,
  PageTitle,
  Byline,
  Paragraph,
  HeroImage,
  HeroCaption
} from '../../styles/exhibitionStyles';

export default function ShopOpening() {
  useEffect(() => {
    document.title = "Sleepr Studio Storefront Opening - SLEEPR";
  }, []);

  return (
    <ExhibitionContainer>
      <HeroImage src="/img/shop/sleepr-studio-storefront.png" alt="Sleepr Studio Storefront" />
      <HeroCaption>New storefront now open.</HeroCaption>

      <PageTitle>Sleepr Studio Storefront Opening</PageTitle>
      <Byline>
        A new storefront is now open with exclusive limited edition prints, apparel, and direct access to oil paintings for studio members.
      </Byline>

      <Paragraph>
        The new Sleepr Studio shop is live, offering a curated selection of limited edition prints, apparel, and special releases. Studio members can access exclusive drops and direct access to oil paintings.
      </Paragraph>
      <Paragraph>
        Visit the storefront here: <a href="https://shop.sleeprstudio.com" target="_blank" rel="noreferrer">https://shop.sleeprstudio.com</a>
      </Paragraph>
    </ExhibitionContainer>
  );
}
